import { useShouldRenderArrayFC } from "@/hooks/useShouldRenderArrayFC";
import { useCallback, useEffect } from "react";
import { useRouter } from "next/router";
import { reviewsContainer } from "@/utils/constants";
import { HomeResponseTO } from "@/models/home";
import { NavBarResponseTO } from "@/models/common/common";
import HomeHead from "./homeHead/HomeHead";
import ItalianTour from "./italianTour/ItalianTour";
import OurManifest from "./OurManifest";
import Brochures from "./brochures/Brochures";
import TravelExperiences from "./TravelExperiences";
import IwantToVisit from "./IwantToVisit";
import TikTokSection from "./TikTokSection";
import TourReview from "./TourReviews";
import FourSteps from "./FourSteps/FourSteps";
import KeepInTouch from "../common/KeepInTouch";
import useVideoReviewData from "../../utils/queries/hooks/useVideoReviewData";
import ItalianStories from "./ItalianStories";
import SocialProof from "./SocialProof";
// TODO: re-add Social Proof After MVP

const HomeBody = ({
    navBarData,
    homeData,
    italianStoriesData,
}: {
    navBarData?: NavBarResponseTO;
    homeData?: HomeResponseTO;
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    italianStoriesData?: any;
}) => {
    // const { data: navBarData } = useNavBarData();
    // const { data: homeData } = useHomeData();
    const { data: videoReviews } = useVideoReviewData();
    // const { data: italianStoriesData } = useGeneralItalianStoriesData();
    const router = useRouter();

    const handleHashChange = useCallback(
        (event?: HashChangeEvent) => {
            // la navigazione diretta per id non è possibile a causa della struttura della pagina e del suo contenuto.
            // E' stato simulato un comportamento simile tramite una gestione manuale.
            const hashToSearch =
                router.asPath.split("#")[1] ?? event?.newURL.split("#")[1];
            if (hashToSearch && hashToSearch === reviewsContainer.hash) {
                const tourReviewsEl = document.getElementById(
                    reviewsContainer.id
                );
                if (tourReviewsEl) {
                    setTimeout(() => {
                        const offsetTop = tourReviewsEl.offsetTop - 70;
                        window.scrollTo({
                            top: offsetTop,
                        });
                    }, 1250);
                }
            }
        },
        [router.asPath]
    );

    useEffect(() => {
        handleHashChange();
        window.addEventListener("hashchange", event => handleHashChange(event));
        return () => {
            window.removeEventListener("hashchange", handleHashChange);
        };
    }, [handleHashChange]);

    return (
        <div className="minWidth100vwFromXL">
            <HomeHead
                smartSearchContent={navBarData!.toursHome}
                destinationToExplore={homeData?.destinationToExplore}
                headImage={homeData!.staticMedia.headImage!}
                altHeadImage={homeData!.staticMedia.metadata?.altHeadImage}
                bannerHome={homeData?.staticMedia.bannerHome}
            />
            {!!homeData?.staticMedia.previewImageVideo &&
                !!homeData?.staticMedia.video && (
                    <OurManifest
                        previewImage={homeData!.staticMedia.previewImageVideo}
                        video={homeData!.staticMedia.video}
                        altPreviewImage={
                            homeData!.staticMedia.metadata?.altPreviewImageVideo
                        }
                    />
                )}
            {useShouldRenderArrayFC(navBarData?.toursHome) && (
                <ItalianTour
                    toursByType={navBarData!.toursHome}
                    wordingsDelta={homeData?.staticMedia.whatDoYouExpectFrom}
                />
            )}
            <TravelExperiences />
            {useShouldRenderArrayFC(homeData?.destinationToExplore) && (
                <IwantToVisit
                    destinations={homeData!.destinationToExplore!}
                    wordingsDelta={homeData?.staticMedia.destinations}
                />
            )}
            <Brochures />
            <FourSteps
                stepperImage={homeData?.staticMedia.stepperImage}
                altStepperImage={
                    homeData?.staticMedia.metadata?.altStepperImage
                }
            />
            {useShouldRenderArrayFC(homeData?.reviews) && (
                <TourReview reviewContents={homeData!.reviews!} />
            )}
            <SocialProof />
            {!!italianStoriesData && (
                <ItalianStories content={italianStoriesData} isFromHome />
            )}
            {videoReviews && (
                <TikTokSection
                    videoReviews={videoReviews}
                    wordingsDelta={homeData?.staticMedia.videoReviews}
                />
            )}
            <KeepInTouch />
        </div>
    );
};

export default HomeBody;
